// src/pages/dashboard/wallet-detail/shared/wallet-utils.ts
import { toast } from 'react-toastify';

// Formatear fecha para que sea más legible
export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

// Función para copiar texto al portapapeles
export const copyToClipboard = (text: string | undefined) => {
  if (!text) return;
  
  navigator.clipboard.writeText(text)
    .then(() => {
      toast.success('Copied to clipboard');
    })
    .catch(() => {
      toast.error('Failed to copy text');
    });
};

// Función para determinar la URL del explorador de blockchain correspondiente
export const getBlockchainExplorerUrl = (currencyType: string | undefined, walletAddress: string | undefined) => {
  if (!currencyType || !walletAddress) return '#';
  
  switch (currencyType.toUpperCase()) {
    case 'BTC':
      return `https://www.blockchain.com/btc/address/${walletAddress}`;
    case 'ETH':
    case 'USDT_ERC20':
      return `https://etherscan.io/address/${walletAddress}`;
    case 'USDT_TRON':
    case 'TRX':
      return `https://tronscan.org/#/address/${walletAddress}`;
    case 'BNB':
     case 'USDT_BEP20':
      return `https://bscscan.com/address/${walletAddress}`;
       default:
      return '#';
  }
};

// Función para obtener el nombre del explorador de blockchain
export const getBlockchainExplorerName = (currencyType: string | undefined) => {
  if (!currencyType) return 'Blockchain Explorer';
  
  switch (currencyType.toUpperCase()) {
    case 'BTC':
      return 'Blockchain.com';
    case 'ETH':
    case 'USDT_ERC20':
      return 'Etherscan';
    case 'USDT_TRON':
    case 'TRX':
      return 'Tronscan';
    case 'USDT_BEP20':
    case 'BNB':
      return 'BscScan';
    
    default:
      return 'Blockchain Explorer';
  }
};